import React from 'react';
import { navigate } from '../../common/services/navigation';

function AToZNavItem({ item, search }) {
	const toggleClass = search.startWith == item ? 'selected' : '';
	let onFilter = e => {
		e.preventDefault();
		let value = e.target.innerHTML;
		navigate(search, {
			startWith: value,
			pageIndex: 0
		})
	};

	const isDisabled = item.resultCount === 0;

	if(!isDisabled){
		return <a className={"a-z-nav__link  a-z-nav__link--" + toggleClass} href="#" onClick={onFilter}>{item}</a>
	} else{
		return <span className={"disabled"}>{item}</span>
	}	
}

export default AToZNavItem;